/**
 * Javascript file for score card.
 * @author Yannik Sprengart, Andrea Villeda.
 */

export default {
    name: "ScoreCard",

    /**
     * The vue instance's data object.
     */
    data() {
        return {};
    },
};


// WEBPACK FOOTER //
// ./src/components/company/kirc/components/scorecard.js